import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TripBookingForm from "./components/TripBookingForm/TripBookingForm";
import BookingConfirmation from "./components/BookingConfirmation";

const App=()=> {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<TripBookingForm />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
